<template>
  <div>
    <div class="mt-2 text-secondary">
      <!-- <header-divider icon="fi fi-layerstore" :title="getTitle"></header-divider> -->
      <h4 class="display-7">
        <div class="d-inline-block"></div>
        <!-- <i class="fi fi-layerstore mx-2" v-if="walletTabSelected != 'transferCredit'"></i> -->
        <!-- <div class="d-inline-block" v-if="walletTabSelected == 'transferCredit'"></div> -->
        <!-- {{ getTitle }} -->
        <button
          class="btn btn-sm float-end"
          @click="backButtonClick"
          v-if="walletTabSelected != 'walletList'"
        >
          بازگشت
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-arrow-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
            ></path>
          </svg>
        </button>
      </h4>

      <!-- <hr class="hr-right" /> -->
    </div>

    <div class="row g-3 align-items-center w-100">
      <wallet-list v-if="walletTabSelected == 'walletList'" />
      <increase-credit
        :selectedWalletID="selectedWalletID"
        v-if="walletTabSelected == 'increaseCredit'"
      />
      <transaction-list
        :selectedWalletID="selectedWalletID"
        v-if="walletTabSelected == 'transactionList'"
      />
      <transfer-credit
        :selectedWalletID="selectedWalletID"
        :clientID="$store.getters.userPersonID"
        v-if="walletTabSelected == 'transferCredit'"
      />
    </div>
  </div>
</template>
<script>
// import HeaderDivider from '../../../../components/utility/headerDivider/HeaderDivider.vue';
import WalletList from './WalletList.vue';
import IncreaseCredit from './IncreaseCredit.vue';
import TransactionList from './TransactionList.vue';
import TransferCredit from './TransferCredit.vue';
// import { useRoute } from 'vue-router';
export default {
  components: {
    WalletList,
    IncreaseCredit,
    TransactionList,
    TransferCredit,
  },
  computed: {
    getTitle() {
      if (this.walletTabSelected == 'transferCredit') return '';
      return `کیف پول ${
        this.walletTabSelected == 'walletList'
          ? ''
          : this.walletTabSelected == 'increaseCredit'
          ? ' / شارژ'
          : this.walletTabSelected == 'transactionList'
          ? ' / گردش حساب'
          : ''
      }`;
    },
  },
  data() {
    return {
      walletTabSelected: 'walletList',
      selectedWalletID: 0,
      // clientID: 0,
      // walletList: [],
      // currencyTypeList: [],
    };
  },
  provide() {
    return {
      SetSelectedTab: this.setSelectedTab,
      SelectedWalletID: this.selectedWalletID,
    };
  },
  inject: ['WalletList', 'RefreshWalletList'],
  methods: {
    // getCurrenyTitle(id) {
    //   let currency = this.currencyTypeList.filter((f) => f.id == id);
    //   if (currency.length > 0) {
    //     return currency[0].title;
    //   }
    //   return '';
    // },
    // getThousandBalance(balance) {
    //   /* eslint-disable */
    //   return thousandSeprator(balance);
    // },

    setSelectedTab(tab, id) {
      this.walletTabSelected = tab;
      this.selectedWalletID = id;
    },
    backButtonClick() {
      this.walletTabSelected = 'walletList';
    },
  },

  async mounted() {
    // const route = useRoute();
    // let that = this;
    // that.clientID = route.params.id;
  },
};
</script>
